module.exports = "query($error: [String!], $days: [String!]) {\n    getErrorMessages(error: $error, days: $days) {\n        count\n        name\n    }\n}\n"